export default () => [
  'Enter Email and Username',
  'Confirm Code',
  'Create New Password',
];
